import React, { Component } from "react";
import Logo from "../design/img/yaystack-logo.svg";
import Icon from "../design/img/icon.png";
import Confetti from "react-confetti";
import ModalRequestAccess from "../modal/ModalRequestAccess";
import AppleLogo from "../design/img/AppStore_US.svg";
import GoogleLogo from "../design/img/google-play-badge.png";

class PresentationView extends Component {
  state = {
    width: window.innerWidth,
    height: window.innerHeight,
    openModal: false
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("orientationchange", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    window.removeEventListener(
      "orientationchange",
      this.updateWindowDimensions
    );
  }

  updateWindowDimensions = _ => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };

  range = function(a, b) {
    return (b - a) * Math.random() + a;
  };

  handleOpenWebsite = _ => {
    let url = "https://apps.apple.com/us/app/yaystack/id1454533902?ls=1";
    window.open(url);
  };

  handleOpenGoogleStore = _=>{
    let url ="https://play.google.com/store/apps/details?id=com.yaystack"
    window.open(url);
  }

  render() {
    return (
      <div className="presentation">
        <Confetti
          opacity={1}
          style={{ zIndex: 0 }}
          width={this.state.width}
          height={this.state.height}
          numberOfPieces={80}
          colors={["#ff5116", "#282560", "#ffc520", "#f69026"]}
          drawShape={ctx => {
            ctx.beginPath();
            let length =
              ~~this.state.width < 500 ? this.range(8, 12) : this.range(16, 24);
            let height =
              ~~this.state.width < 500
                ? this.range(18, 22)
                : this.range(36, 44);
            this.range(36, 44);
            ctx.rect(0, 0, length, height);
            ctx.stroke();
            ctx.closePath();
            ctx.fill();
          }}
        />
        <div class="row row_portrait">
          <div class="col-sm">
            <img src={Logo} class="logo_yaystack"></img>
            <label
              className="presentation-subtitle-light presentation-best"
              style={{}}
            >
              The Best Finds From Your Best Friends
            </label>

            <img
              src={AppleLogo}
              onClick={this.handleOpenWebsite}
              style={{ marginTop: "2vh", width:'20vw',height: '6.5vw', marginRight:10, cursor:'pointer'  }}
            />
            {/* <img*/}
            {/*  src={GoogleLogo}*/}
            {/*  onClick={this.handleOpenGoogleStore}*/}
            {/*  style={{ marginTop: "2vh", width:'20vw', height: '6.5vw',marginLeft:10, cursor:'pointer' }}*/}
            {/*/>*/}
          </div>
        </div>

        <div class="row row_landscape">
          <div class="col-sm">
            <img
              src={Logo}
              style={{ maxWidth: "40%", marginTop: "10vh" }}
            ></img>
            <label
              className="presentation-subtitle-light"
              style={{ marginTop: "10px", fontSize: "2vw" }}
            >
              The Best Finds From Your Best Friends
            </label>
            <img
              src={AppleLogo}
              onClick={this.handleOpenWebsite}
              style={{ marginTop: "2vh", width:'20vw',height: '6.5vw', marginRight:10, cursor:'pointer'  }}
            />
            {/* <img*/}
            {/*  src={GoogleLogo}*/}
            {/*  onClick={this.handleOpenGoogleStore}*/}
            {/*  style={{ marginTop: "2vh", width:'20vw', height: '6.5vw',marginLeft:10, cursor:'pointer'  }}*/}
            {/*/>*/}
          </div>
        </div>
        <label
          className="presentation-subtitle-light"
          style={{
            bottom: "10vh",
            fontSize: "18px",
            position: "fixed",
            width: "100%",
            textAlign: "center"
          }}
        >
          <a href="mailto:trey@yaystack.co">Contact Us</a>
        </label>
      </div>
    );
  }
}

export default PresentationView;



// WEBPACK FOOTER //
// ./src/pages/presentation.jsx